import React from 'react';
import '../App.css';
import Header from './header';
import GITHUB from '../image/github.png';
import FACEBOOK from '../image/facebook.png';
import INSTAGRAM from '../image/instagram.png';
import Linkedin from '../image/linkedin.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
const GIT = "www.ggg.in";
function Menu({children,
    className="center",
    }){
    return(
        <div className="">
            <Header></Header>
            <div className="row left">
               
                <div className="col-1 d-none d-md-block">
                   <ul className="left-side list" >
                      
                   <a href="github"><li className="social"><span><img class="icon" src={GITHUB}/></span></li></a>
                   <a href="linkedin"><li className="social"><span><img class="icon" src={Linkedin}/></span></li></a>
                   <a href="facebook"><li className="social"><span><img class="icon" src={FACEBOOK}/></span></li></a>
                   <a href="instagram"> <li className="social"><span><img class="icon" src={INSTAGRAM}/></span></li></a>
                   </ul>
                </div>
                <div className="col-12 col-md-10">
                    {children}
                </div>
                
                <div className="col-1 right-side d-none d-md-block" align="right">
                   <p className="right-side">karanpatel2329@gmail.com</p> 
                </div>
            </div>
             
        </div>
    )
}

export default Menu;